import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBooleanState } from '../../../features/videoPlayer/videoPlayer.slice'

export const useHoveringListener = (isMobile, isTablet) => {

    const hovering = useSelector((state) => state.videoPlayer.hovering);
    const isInteracting = useSelector((state) => state.videoPlayer.isInteracting);
    const isBuffering = useSelector((state) => state.videoPlayer.isBuffering);

    const dispatch = useDispatch();

    useEffect(() => {
    let timeout;
    const delay = isMobile || isTablet ? 5000 : 3000; // Longer delay for mobile/tablet
    if (hovering && !isInteracting && !isBuffering) {
      timeout = setTimeout(() => {
        dispatch(setBooleanState({ key: 'hovering', value: false }));
        dispatch(setBooleanState({ key: 'showSettings', value: false }));
        dispatch(setBooleanState({ key: 'settingsView', value: 'main' }));
      }, delay); // Auto-hide after 3 seconds
    }
    return () => clearTimeout(timeout); // Clear timeout on cleanup
  }, [hovering, isInteracting, isBuffering]);
};